import Styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
export const EmbeddedSnackbarContainer = Styled.div`
  width: 450px;
  margin: 0 auto;
  padding: 20px 18px;
  border-radius: 4px;
  box-sizing: border-box;
  display: none;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  overflow: hidden;
  &.show-snackbar {
    display: flex;
  }
  & img {
    float: none;
    margin-right: 15px;
  }
  & p {
    flex: 2;
    line-height: 20px;
    color: ${COLORS.black};
  }
  &.warning {
    background-color: ${COLORS.lightGrey};
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
  }
`;
